import "./navbar.css";
import Logo from "../../images/logo.png";
import { Link } from "react-router-dom";
// import { useState } from "react";
// import { Drawer } from "antd";
// import { PospMenu } from "../Posp/Menu";

export const PospNavBar = () => {
  // const [DrawClick, setDrawClick] = useState('')
  
  // const [open, setOpen] = useState(false);
  //   const showDrawer = () => {
  //     setDrawClick('')
  //     setOpen(true);
  //   };
  //   const onClose = () => {
  //     setOpen(false);
  //   };
 
  return (
    <header className="bg-white w-100 d-block" style={{ height: "50px" }}>
      <div className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="text-decoration-none">
          <img
            src={Logo}
            className="navbar-brand mt-0 position-relative"
            style={{ maxWidth: "150px" }}
            alt=""
          />
        </Link>
        {/* <Link to="/PospMenu"  className="text-decoration-none"></Link> */}
          {/* <p className="mb-0 posp-nav-txt">View Offline Request</p> */}
       
      </div>
      {/* <Drawer title="Posp Menu" 
        className="open-posp"
        width={DrawClick ? `100%` : 312} 
        // closable={false} 
        maskClosable={false}
        onClose={onClose} 
        open={open}>
        <PospMenu setDrawClick={setDrawClick} open={open} setOpen={setOpen} />
        </Drawer> */}
    </header>
  );
};
